import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";




class RechercheInnovation extends Component {
  render() {
    return (
    <div>   
     <section className="inner-intro bg-image  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg6.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Nos services</a>/<span>Recherche & Innovation</span>
                    </div>
                </div>
            </div>
        </section>
        
   <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                
                    <div className="col-md-8">
                    <div className="content">
                    <h3 className="search_inno"><img src="/assets/img/leaf.png" className="leaf-sidebar"/> Recherche & Innovation</h3>
                        <p>C’est à Keur Moussa, à quelques pas de son usine, que Green Agro Business a choisi d’implanter son périmètre de tests et démonstrations et faire de la recherche et innover ses solutions respectueuses de l’environnement.</p>
                        <p>Grâce aux échanges quotidiens avec nos techniciens conseils terrain, notre équipe agronome travaille sur la création de nouvelles gammes de produits répondant toujours plus aux attentes de nos clients.</p>
                        <div className="accordion">
                            <div className="accordion-section">
                                <h6 className="accordion-title  accor_title_tech">Recherche</h6>
                                <div className="accordion-content ">
                                    <p>La recherche sur les formules NPK adaptées aux terrains.</p>
                                </div>
                            </div>
                            <div className="accordion-section">
                                <h6 className="accordion-title accor_title_tech">Test produits</h6>
                                <div className="accordion-content">
                                    <p>Les tests sur les doses de produits à préconiser pour un rendement optimum.</p>
                                   
                                </div>
                            </div>
                            <div className="accordion-section">
                                <h6 className="accordion-title accor_title_tech">Accompagnement</h6>
                                <div className="accordion-content">
                                   <p>L’accompagnement des semenciers sur le développement de nouvelles variétés en plein champs et conditions réelles (Maraichères, Fruitières, grandes cultures).</p>

                                </div>
                            </div>
                            <div className="accordion-section">
                                <h6 className="accordion-title accor_title_tech">Partenariats</h6>
                                <div className="accordion-content">
                                    <p>Partenariats efficaces, adaptés à la zone Ouest Africaine sur la recherche de produits Innovants comme les bio stimulants, bio pesticides.</p>
                                </div>
                            </div>
                        </div>
                      
                        <p>Le périmètre de tests et démonstrations permet d’apporter des solutions adaptées et innovantes pour l’agriculture de demain, dans un respect du sol, de la plante et du consommateur.</p>
                    </div>
                    </div>
                    <Sidebar/> 
                </div>
            
            </div>
        </section>
        <hr/>
    </div>
    )
  }
}
export default RechercheInnovation


// WEBPACK FOOTER //
// ./src/components/recherche_innovation.jsx